import React from "react";

export const AquasaveLogo = ({ size = 40, showText = true, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`} data-testid="aquasave-logo">
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="aq-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3EB6F0" />
          <stop offset="1" stopColor="#0F2E5C" />
        </linearGradient>
      </defs>
      <path d="M50 8 C 30 32, 22 50, 22 62 a 28 28 0 0 0 56 0 C 78 50, 70 32, 50 8 Z" fill="url(#aq-grad)" opacity="0.95" />
      <circle cx="66" cy="42" r="4" fill="#3EB6F0" />
      <circle cx="76" cy="58" r="3.5" fill="#3EB6F0" />
      <circle cx="62" cy="68" r="3" fill="#0F2E5C" />
      <line x1="66" y1="42" x2="76" y2="58" stroke="#3EB6F0" strokeWidth="1.4" opacity="0.85" />
      <line x1="76" y1="58" x2="62" y2="68" stroke="#3EB6F0" strokeWidth="1.4" opacity="0.85" />
      <line x1="66" y1="42" x2="62" y2="68" stroke="#3EB6F0" strokeWidth="1.2" opacity="0.7" />
      <circle cx="45" cy="55" r="8" fill="#0F2E5C" />
      <circle cx="45" cy="55" r="3" fill="#070B14" />
    </svg>
    {showText && (
      <div className="font-heading font-extrabold tracking-tight text-xl leading-none">
        <span className="text-[#3EB6F0]">AQUA</span><span className="text-slate-200">save</span>
      </div>
    )}
  </div>
);
